import React, { useEffect, useState, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../styles/OurCreations.css";

// ===== keep all existing imports exactly as in current file =====
// import img1 from "../../assets/hero/hero1.jpg";
// import img2 from "../../assets/hero/hero2.jpg";
// import img3 from "../../assets/hero/hero3.png";
// import img4 from "../../assets/hero/hero4.png";
// import img5 from "../../assets/hero/hero5.jpeg";
// import img6 from "../../assets/hero/hero6.jpg";
// import img7 from "../../assets/hero/hero7.jpg";
// import img8 from "../../assets/hero/hero8.jpg";
// Wall
import img9 from "../../assets/wall/wallUnits.jpg";
import img10 from "../../assets/wall/wallUnits1.jpg";
import img11 from "../../assets/wall/wallUnits2.jpg";
import img12 from "../../assets/wall/wallUnits3.jpeg";
import img13 from "../../assets/wall/wallUnits4.jpeg";
import img14 from "../../assets/wall/wallUnits6.jpg";
//Divine 
import img15 from "../../assets/divine/1.webp";
import img16 from "../../assets/divine/2.jpg";
import img17 from "../../assets/divine/3.jpeg";
import img18 from "../../assets/divine/4.avif";
import img19 from "../../assets/divine/5.jpg";
import img20 from "../../assets/divine/6.png";
//Custom dinein
import img21 from "../../assets/customDineIn/1.png";
import img22 from "../../assets/customDineIn/2.webp";
import img23 from "../../assets/customDineIn/3.jpg";
import img24 from "../../assets/customDineIn/4.jpg";
import img25 from "../../assets/customDineIn/5.webp";
import img26 from "../../assets/customDineIn/6.jpg";
//wardobe
import img27 from "../../assets/wardobe/1.jpeg";
import img28 from "../../assets/wardobe/2.jpg";
import img29 from "../../assets/wardobe/3.jpg";
import img30 from "../../assets/wardobe/4.jpeg";
import img31 from "../../assets/wardobe/5.webp";
import img32 from "../../assets/wardobe/6.webp";
//Enteraintment 
import img33 from "../../assets/Enteraintment/1.jpg";
import img34 from "../../assets/Enteraintment/2.avif";
import img35 from "../../assets/Enteraintment/3.jpg";
import img36 from "../../assets/Enteraintment/4.jpg";
import img37 from "../../assets/Enteraintment/5.jpg";
import img38 from "../../assets/Enteraintment/6.jpg";
//Executive Suite 
import img39 from "../../assets/Executive/1.webp";
import img40 from "../../assets/Executive/2.webp";
import img41 from "../../assets/Executive/3.webp";
import img42 from "../../assets/Executive/4.webp";
import img43 from "../../assets/Executive/5.webp";
import img44 from "../../assets/Executive/6.webp";
import img72 from "../../assets/Executive/7.webp";

//Breakfast Counters
import img45 from "../../assets/breakfast/1.jpg";
import img46 from "../../assets/breakfast/22.jpg";
import img47 from "../../assets/breakfast/3.jpg";
import img48 from "../../assets/breakfast/4.jpg";
import img49 from "../../assets/breakfast/5.jpg";
import img50 from "../../assets/breakfast/6.avif";
//Model kitchen 
import img51 from "../../assets/modern-kitchen/1.webp";
import img52 from "../../assets/modern-kitchen/2.jpg";
import img53 from "../../assets/modern-kitchen/3.jpg";
import img54 from "../../assets/modern-kitchen/4.jpeg";
import img55 from "../../assets/modern-kitchen/5.jpeg";
import img56 from "../../assets/modern-kitchen/6.jpeg";

// ===== data (unchanged) =====
const CARD_DATA = [
  { id: 1, title: "Partition Wall Units", img: img14, desc: "Elegant partition units with integrated storage." },
  { id: 2, title: "Divine Paces", img: img20, desc: "Premium interior spaces crafted to perfection." },
  { id: 3, title: "Custom Dining", img: img25, desc: "Tailored dining sets with durable finishes." },
  { id: 4, title: "Wardrobe Units", img: img32, desc: "Smart, space-optimized wardrobes and closets." },
  { id: 5, title: "Entertainment Counter", img: img35, desc: "Media counters with cable management." },
  { id: 6, title: "Executive Office Suite", img: img40, desc: "Executive desks, credenzas, and storage." },
  { id: 7, title: "Breakfast Counters", img: img50, desc: "Compact counters for daily comfort." },
];

const GALLERY_DATA = {
  "Divine Paces": [img15, img16, img17,img18,img19,img20],
  "Custom Dining": [img21, img22, img23,img24,img25,img26],
  "Partition Wall Units": [img9, img10, img11,img12,img13,img14],
  "Wardrobe Units": [img27, img28, img29,img30,img31,img32],
  "Entertainment Counter": [img33, img38, img34,img35,img36,img37],
  "Executive Office Suite": [img44,img39,img40,img41,img42,img43,img72],
  "Breakfast Counters": [img45,img46,img47,img48,img49,img50],
  "Modern Kitchen Remodel": [img51,img52,img53,img54,img55,img56],
};

// ===== Dribbble‑style popup gallery component =====
function GalleryPopup({ open, onClose, title, images, startIndex = 0 }) {
  const [index, setIndex] = useState(startIndex);
  const [direction, setDirection] = useState(0);

  useEffect(() => {
    if (open) {
      setIndex(startIndex);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => (document.body.style.overflow = "");
  }, [open, startIndex]);

  const prev = useCallback(() => {
    setDirection(-1);
    setIndex((i) => (i - 1 + images.length) % images.length);
  }, [images.length]);

  const next = useCallback(() => {
    setDirection(1);
    setIndex((i) => (i + 1) % images.length);
  }, [images.length]);

  const handleKey = useCallback(
    (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    },
    [next, onClose, prev]
  );

  useEffect(() => {
    if (!open) return;
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open, handleKey]);

  if (!open) return null;

  // motion variants for layered ovals
  const stage = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.25 } },
    exit: { opacity: 0, transition: { duration: 0.2 } },
  };

  const slide = {
    initial: (dir) => ({
      x: dir > 0 ? 60 : -60,
      opacity: 0,
      filter: "blur(8px)",
      scale: 0.98,
    }),
    animate: {
      x: 0,
      opacity: 1,
      filter: "blur(0px)",
      scale: 1,
      transition: { duration: 0.55, ease: [0.2, 0.8, 0.2, 1] },
    },
    exit: (dir) => ({
      x: dir > 0 ? -60 : 60,
      opacity: 0,
      filter: "blur(8px)",
      scale: 0.98,
      transition: { duration: 0.45, ease: [0.2, 0.8, 0.2, 1] },
    }),
  };

  // small side thumbs pulse in
  const thumbVar = {
    hidden: { opacity: 0, y: 20 },
    show: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: 0.08 * i, duration: 0.35 },
    }),
  };

  return (
    <AnimatePresence>
      <motion.div
        className="hcg-overlay"
        onClick={onClose}
        variants={stage}
        initial="initial"
        animate="animate"
        exit="exit"
      >
        <motion.div
          className="hcg-modal"
          onClick={(e) => e.stopPropagation()}
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1, transition: { duration: 0.35 } }}
          exit={{ y: 30, opacity: 0, transition: { duration: 0.25 } }}
        >
          <div className="hcg-header">
            <h3 className="hcg-title">{title}</h3>
            <div className="hcg-count">{index + 1} / {images.length}</div>
            <button className="hcg-close" onClick={onClose} aria-label="Close">×</button>
          </div>

          {/* Center stage with 3 oval frames like the Dribbble shot */}
          <div className="hcg-stage">
            <button className="hcg-arrow left" onClick={prev} aria-label="Previous">‹</button>

            <div className="hcg-ovals">
              {/* left small oval */}
              <motion.div
                className="hcg-oval hcgo-small"
                custom={0}
                variants={thumbVar}
                initial="hidden"
                animate="show"
                key={`left-${index}`}
              >
                <img
                  src={images[(index - 1 + images.length) % images.length]}
                  alt="previous"
                  draggable="false"
                />
              </motion.div>

              {/* large middle oval */}
              <div className="hcgo-large">
                <AnimatePresence custom={direction} mode="popLayout">
                  <motion.img
                    key={images[index]}
                    src={images[index]}
                    alt="current"
                    variants={slide}
                    custom={direction}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    draggable="false"
                  />
                </AnimatePresence>
              </div>

              {/* right small oval */}
              <motion.div
                className="hcg-oval hcgo-small"
                custom={1}
                variants={thumbVar}
                initial="hidden"
                animate="show"
                key={`right-${index}`}
              >
                <img
                  src={images[(index + 1) % images.length]}
                  alt="next"
                  draggable="false"
                />
              </motion.div>
            </div>

            <button className="hcg-arrow right" onClick={next} aria-label="Next">›</button>
          </div>

          {/* bottom dots + strip */}
          <div className="hcg-dots">
            {images.map((_, i) => (
              <button
                key={i}
                aria-label={`Go to ${i + 1}`}
                className={`hcg-dot ${i === index ? "active" : ""}`}
                onClick={() => setIndex(i)}
              />
            ))}
          </div>

          <div className="hcg-strip">
            {images.map((src, i) => (
              <button
                key={src + i}
                className={`hcg-thumb ${i === index ? "active" : ""}`}
                onClick={() => setIndex(i)}
              >
                <img src={src} alt={`thumb ${i + 1}`} />
              </button>
            ))}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}

const OurCreations = () => {
  // ===== keep carousel state/logic the same as current file =====
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  // NEW: popup state
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupImages, setPopupImages] = useState([]);
  const [popupStartIndex, setPopupStartIndex] = useState(0);

  // autoplay
  useEffect(() => {
    const t = setInterval(() => {
      if (isAnimating) return;
      setIsAnimating(true);
      setCurrentIndex((i) => (i + 1) % CARD_DATA.length);
      setTimeout(() => setIsAnimating(false), 800);
    }, 3500);
    return () => clearInterval(t);
  }, [isAnimating]);

  const updateCarousel = (i) => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prev) => {
      const total = CARD_DATA.length;
      return (i + total) % total;
    });
    setTimeout(() => setIsAnimating(false), 800);
  };

  // click handler: opens popup with that card’s gallery starting at first image
  const handleOpenPopup = useCallback((card, start = 0) => {
    const imgs = GALLERY_DATA[card.title] || [];
    setPopupTitle(card.title);
    setPopupImages(imgs);
    setPopupStartIndex(start);
    setPopupOpen(true);
  }, []);

  const closePopup = useCallback(() => setPopupOpen(false), []);

  // ====== UI (INITIAL VIEW KEPT THE SAME) ======
  return (
    <section id="portfolio"  className="oc3-wrap" style={{ minHeight: "100vh", padding: "100px 20px" }}>
      <div className="oc3-container">
        <h1 className="about-title">OUR CREATIONS</h1>

        {/* Carousel (keep layout – only add onClick) */}
        <div className="carousel-container">
          <button className="nav-arrow left" onClick={() => updateCarousel(currentIndex - 1)}>‹</button>

          <div className="carousel-track">
            {CARD_DATA.map((card, i) => {
              const offset = (i - currentIndex + CARD_DATA.length) % CARD_DATA.length;
              let cls = "hidden";
              if (offset === 0) cls = "center";
              else if (offset === 1) cls = "right-1";
              else if (offset === 2) cls = "right-2";
              else if (offset === CARD_DATA.length - 1) cls = "left-1";
              else if (offset === CARD_DATA.length - 2) cls = "left-2";

              return (
                <div
                  key={card.id}
                  className={`card ${cls}`}
                  onClick={() => handleOpenPopup(card, 0)}
                  role="button"
                >
                  <img src={card.img} alt={card.title} />
                </div>
              );
            })}
          </div>

          <button className="nav-arrow right" onClick={() => updateCarousel(currentIndex + 1)}>›</button>
        </div>

        {/* Info */}
        <div className="member-info">
          <h2 className="member-name">{CARD_DATA[currentIndex].title}</h2>
          <p className="member-role">{CARD_DATA[currentIndex].desc}</p>
        </div>

        {/* Dots */}
        <div className="dots">
          {CARD_DATA.map((_, i) => (
            <div
              key={i}
              className={`dot ${i === currentIndex ? "active" : ""}`}
              onClick={() => updateCarousel(i)}
            />
          ))}
        </div>
      </div>

      {/* Popup mounted above initial layout */}
      <GalleryPopup
        open={popupOpen}
        onClose={closePopup}
        title={popupTitle}
        images={popupImages}
        startIndex={popupStartIndex}
      />
    </section>
  );
};

export default OurCreations;
